<template>
  <div class="com-box">
    <img class="head-img" src="https://img3.quanyou.com.cn/joyNew/group1/M00/1C/ED/rB8LrWUvjOuAdVb9AAFqRFHpBAk140.png" alt="" />
    <div class="card">
      <div class="centent" >
        <div class="title" v-if="attentionTitle">
          <img src="https://img3.quanyou.com.cn/joyNew/group1/M00/1D/06/rB8LrWUwweGAC4fYAAAC1BJnx40509.png" alt="" />
          <span class="title-title">{{attentionTitle}}</span>
          <img src="https://img3.quanyou.com.cn/joyNew/group1/M00/1D/06/rB8LrWUwweGAC4fYAAAC1BJnx40509.png" alt="" />
        </div>
        <div v-html="attentionMsg"></div>
      </div>
    </div>
  </div>
</template>

<script>
import mixins from './mixins'
export default {
  mixins: [mixins]
}
</script>

<style lang="stylus" scoped>
  .com-box {
    .head-img {
      width: 100%;
      height: 107px;
    }
    .card {
      width: 100%;
      min-height: 165px;
      margin-top: -30px;
      background: url('https://img3.quanyou.com.cn/joyNew/group1/M00/1C/CD/rB8LrWUuMYKAfrcrAABVN5ga_IY928.png');
      background-size: 100% 100%;
      padding-bottom: 30px;
      overflow hidden
      box-sizing: border-box;
      .centent {
        width: 330px;
        min-height: 100px;
        // background: linear-gradient(0deg, #030000, #FFFFFF);
        color: #E24409;
        font-size: 14px;
        box-shadow: 0px 3px 10px 0px rgba(196,99,3,0.7);
        border-radius: 5px;
        margin: auto;
        margin-top: 30px;
        padding: 15px 12px;
        box-sizing: border-box;
        background: linear-gradient(0deg, #FFF3DF, #FFFCF6);
        .title {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 10px;
          .title-title {
            color: #E24409;
            margin: 0 6px;
            font-weight: bold;
          }
          img {
            width: 14px;
            height: 14px;
          }
        }
      }
    }
  }
</style>